import React, { Component } from "react";

export default class KcFooter extends Component {
	render() {
		return (
			<footer className="main-footer d-flex align-items-center justify-content-between">
				<span>&copy; {new Date().getFullYear()} PT Klikcair Magga Jaya. All Rights Reserved.</span>
				<span>Telah berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK)</span>
			</footer>
		);
	}
}
